import { render, staticRenderFns } from "./SendSchedule.vue?vue&type=template&id=35b63b82&scoped=true&"
import script from "./SendSchedule.vue?vue&type=script&lang=js&"
export * from "./SendSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b63b82",
  null
  
)

export default component.exports